<template>
    <div>
        <modal-warper :target="id" :show="exibir" @close="(exibir = false)">
            <Modal :id="id" :size="'modal-xl'" :open="exibir" :FooterDefault="false" :ClassBG="true" :customModalMain="'z-index:1055'">

                <template v-slot:header>
                    <h6 class="modal-title">Ticket</h6>
                    <button type="button" class="btn" data-bs-dismiss="modal" aria-label="Close" @click="fecharModal()">
                        <i class="fas fa-times btn-close-style-v2 hover-effect"></i>
                    </button>
                </template>

                <template v-slot:body>
                    <div class="body">
                        <Ticket v-if="p_idOcorrencia > 0" ref="modal_ticket" :idOcorrencia="p_idOcorrencia"
                                :tabComponentDefault="'Dados'" :cdSetor="cdSetor" :idProcesso="p_idProcesso"
                                :cdSetorClassificacao="cdSetorClassificacao" :idModulo="p_idModulo"
                                @liberaAvancarEtapa="liberaAvancarEtapa" :show="showTicket"
                                @liberaUltimaEtapa="liberaUltimaEtapa" @tab-clicked="handleTabClick"
                                @handleButtonProcessoTabTickets="handleButtonProcessoTabTickets"
                                @setNovoProcessoTickets="setNovoProcessoTickets" @setActionCard="setActionCard"
                                :ocorrenciaTabSelect="p_cdOcorrenciaTab" />
                    </div>

                    <modal-warper target="ModalPularEtapa" :show="isOpenModalPularEtapa"
                                  @close="(isOpenModalPularEtapa = false)">
                        <Modal id="ModalPularEtapa" :size="''" :open="isOpenModalPularEtapa"
                               :customSizeWid="'width:600px;margin: 0 auto;padding-top:8rem;'" :FooterDefault="false"
                               :ClassBG="true" :customModalBody="dinamicHeightConsChange">

                            <template v-slot:header>
                                <h6 class="modal-title">
                                    Motivo
                                </h6>
                                <button type="button" class="btn" data-bs-dismiss="modal" aria-label="Close">
                                    <i class="fas fa-times btn-close-style-v2 hover-effect"></i>
                                </button>
                            </template>

                            <template v-slot:body>
                                <p style="color: black; font-weight: bold; margin: 0;">
                                    <b>
                                        Selecione abaixo o motivo para
                                        pular esta Etapa
                                    </b>
                                </p>
                                <div class="col-12 customSelect">
                                    <label class="form-label mb-1 mt-2"
                                           name="dsSetorClassificacaoMotivoAvancarEtapa">Motivo</label>
                                    <vue-select v-model="motivoPularEtapaSelect" :options="motivoPularEtapa"
                                                placeholder="Selecione"
                                                :label-by="(m) => (m.dsSetorClassificacaoMotivoAvancarEtapa)"
                                                class="form-control shadow-v2" close-on-select clear-on-select searchable
                                                search-placeholder="Pesquise"></vue-select>
                                </div>
                            </template>

                            <template v-slot:footer>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-close-clean-v2 mt-2" data-bs-dismiss="modal">
                                        Fechar
                                    </button>
                                    <button type="button" class="btn btn-red-v2"
                                            @click="setMotivoPularEtapa(motivoPularEtapaSelect.idSetorClassificacaoMotivoAvancarEtapa)">
                                        <i class='fa fa-check pe-2'></i>
                                        Concluir
                                    </button>
                                </div>
                            </template>

                        </Modal>
                    </modal-warper>



                </template>

                <template v-slot:footer>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-close-clean-v2 mt-2" data-bs-dismiss="modal"
                                @click="fecharModal()">
                            Fechar
                        </button>
                        <button type="button" class="btn btn-white-v2" style="border-radius:5px"
                                @click="postMotivoPularEtapa()" v-if="showPularEtapa">
                            Pular Etapa<i class="fas fa-fast-forward l-5" style="margin-top:3px;"></i>
                        </button>

                        <button type="button" class="btn btn-red-v2" @click="postAvancarEtapa()" v-if="flAvancarEtapaTicket && setTabId === 2 && textAvancarEtapa != 'Finalizar Ticket'">
                            {{ textAvancarEtapa }} <i class="fas fa-step-forward l-5" style="margin-top:3px;margin-left:4px"></i>
                        </button>
                       
                        <div v-if="setTabId === 10">
                            <button type="button" class="btn btn-red-v2" v-if="flNovoProcesso && idEmitProcesso == 0" @click="submitEmitirProcesso()">
                                <i class="fa fa-save pe-2"></i>
                                Incluir
                            </button>
                            <button type="button" class="btn btn-red-v2" v-else-if="!flNovoProcesso && idEmitProcesso > 0" @click="submitEmitirProcesso()">
                                <i class="fas fa-save pe-2"></i>
                                Alterar
                            </button>                        
                        </div>

                    </div>
                </template>
            </Modal>

        </modal-warper>

        <modal-warper target="ticket_reclassificar" :show="isOpenModalTrocarSetor" @close="isOpenModalTrocarSetor = false">
            <Reclassificar :idOcorrencia="p_idOcorrencia" :cdSetor="cdSetor" :cdSetorClassificacao="cdSetorClassificacao" :idModulo="p_idModulo" :show="isOpenModalTrocarSetor" @fechou_modal="fechou_modal" />
        </modal-warper>

        <modal-warper target="ticket_historico" :show="isOpenModalHistorico" @close="isOpenModalHistorico = false">
            <Historico :idOcorrencia="p_idOcorrencia" :show="isOpenModalHistorico" ref="ticket_historico" />
        </modal-warper>

        <modal-warper target="ticket_finalizar" :show="isOpenModalFinalizar" @close="isOpenModalFinalizar = false">
            <Finalizar :idOcorrencia="p_idOcorrencia" :show="isOpenModalFinalizar" :cdSetor="cdSetor" @fechou_ticket="fechou_ticket" />
        </modal-warper>

    </div>
</template>

<script>

    import axios from 'axios';
    import VueNextSelect from 'vue-next-select'
    import 'vue-next-select/dist/index.min.css'
    import Modal from '@/components/App/Modal.vue'
    import ModalWarper from '@/components/App/ModalWarper.vue'

    import Ticket from '@/views/Modais/Ocorrencia/Modais/Ticket.vue'

    import Reclassificar from '@/views/Modais/Ocorrencia/Modais/Ocorrencia_Reclassificar.vue'
    import Historico from '@/views/Modais/Ocorrencia/Modais/Ticket_Historico.vue'
    import Finalizar from '@/views/Modais/Ocorrencia/Modais/Ticket_Finalizar.vue'

    export default {
        name: 'Ocorrencia',
        props: {
            p_exibir: {
                type: Boolean,
                default: false
            },
            id: {
                type: String,
                default: 'ModalTicket'
            },
            p_idModulo: {
                type: Number,
                default: 0
            },
            p_idOcorrencia: {
                type: Number,
                default: 0
            },
            p_idProcesso: {
                type: Number,
                default: 0
            },
            p_cdOcorrenciaTab: {
                type: Number,
                default: 1
            },
        },
        components: {
            'vue-select': VueNextSelect,
            Modal,
            ModalWarper,
            Ticket,
            Reclassificar,
            Historico,
            Finalizar
        },
        data() {
            return {
                exibir: false,
                cdSetor: 0,
                classificacoes: [],
                cdSetorClassificacao: 0,
                etapas: [],
                isOpenModalPularEtapa: false,
                isOpenModalTrocarSetor: false,
                dinamicHeightConsChange: 'min-height:calc(100vh - 21rem);',
                NotLoading: false,
                flAvancarEtapaTicket: false,
                textAvancarEtapa: '',
                setTabId: 0,
                isOpenModalHistorico: false,
                isOpenModalFinalizar: false,
                isPularEtapa: false,
                motivoPularEtapa: [],
                motivoPularEtapaSelect: [],
                showTicket: false,
                /* Processo */
                flNovoProcesso: false,
                idEmitProcesso: 0,
            }
        },
        computed: {
            showPularEtapa() {
                return this.setTabId === 2 && this.isPularEtapa == true
            }
        },

        methods: {
            handleButtonProcessoTabTickets(val) {
                this.idEmitProcesso = val;
            },
            setNovoProcessoTickets(val) {
                this.flNovoProcesso = val;
            },
            submitEmitirProcesso() {
                this.$refs.modal_ticket.submitEmitirProcesso();
            },
            showModalTicket() {
                let $this = this;

                this.getMotivoPularEtapa();

                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Ocorrencia/GetDadosModal?idOcorrencia=' + this.p_idOcorrencia, {
                    headers: this.$api.getTokenComercial(),
                    params: ''
                }).then(response => {
                    $this.cdSetor = response.data.data.cdSetor;
                    $this.cdSetorClassificacao = response.data.data.cdSetorClassificacao;
                    $this.exibir = true;
                    $this.showTicket = true;
                    try {
                        this.$nextTick(() => {
                            this.$refs.modal_ticket.reloadContent();
                        })

                    } catch (error) {
                        console.log("reload");
                    }
                })
            },
            varificaTicketEtapa() {
                let $this = this;

                var etapas = {};
                this.etapas.forEach((etapa) => {
                    etapas[etapa.idSetorClassificacaoEtapa] = etapa.flPularEtapa;

                })

                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Ocorrencia/GetId?id=' + this.p_idOcorrencia, {
                    headers: this.$api.getTokenComercial(),
                    params: '',
                    notLoading: true
                }).then(response => {

                    $this.getVerificaEtapa(response.data.data.idSetorClassificacaoEtapaAtual)

                })
            },
            getVerificaEtapa(idSetorClassificacaoEtapa) {
                let $this = this;

                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/SetorClassificacaoEtapa/Get/' + idSetorClassificacaoEtapa, {
                    headers: this.$api.getTokenComercial(),
                    params: '',
                    notLoading: true
                }).then(response => {
                    $this.isPularEtapa = response.data.data.flPularEtapa;
                })
            },
            setMotivoPularEtapa(idMotivo) {
                let $this = this;

                let content = { idOcorrencia: this.p_idOcorrencia, idSetorClassificacaoMotivoAvancarEtapa: idMotivo }

                if (content.idSetorClassificacaoMotivoAvancarEtapa == 0 || content.idSetorClassificacaoMotivoAvancarEtapa == null || content.idSetorClassificacaoMotivoAvancarEtapa == undefined) {
                    $this.$toast.show('alert', 'Selecione um Motivo', true);
                    return;
                }

                axios.post(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Ocorrencia/PostPularEtapa/', content, { headers: this.$api.getTokenComercial() })
                    .then((response) => {

                        this.$refs.modal_ticket.reloadGridsTarefaExecutar();

                        this.isOpenModalPularEtapa = false;

                        this.varificaTicketEtapa();

                        this.motivoPularEtapaSelect = [];

                    })
                    .catch(function (error) {
                        var msg = 'Ocorreu um erro inesperado';
                        if (error.response) {
                            if (error.response.data.erros != '') {
                                msg = error.response.data.errors[0];
                            } else {
                                msg = error.response.data.msg;
                            }
                        }
                        $this.$toast.show('alert', msg, true);
                    });
            },
            getMotivoPularEtapa() {
                let $this = this;
                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/SetorClassificacaoMotivoAvancarEtapa/Get', {
                    headers: this.$api.getTokenComercial(),
                    params: '',
                    notLoading: true
                }).then(response => {
                    $this.motivoPularEtapa = response.data.data.rows;
                })
            },
            postMotivoPularEtapa() {
                this.isOpenModalPularEtapa = true;

            },
            handleTabClick(tabId) {
                this.setTabId = tabId;
            },
            fecharModal() { this.$emit("fecharModal", 'Ocorrencia'); },
            setActionCard(action) {
                let $this = this;

                switch (action) {
                    case 'historico':
                        $this.$refs.ticket_historico.refreshModal();
                        $this.isOpenModalHistorico = true;
                        break;
                    case 'finalizar':
                        $this.isOpenModalFinalizar = true;
                        break;
                    case 'reclassificar':
                        $this.isOpenModalTrocarSetor = true;
                        break;
                    default:
                        break;
                }
                this.$emit('setActionCard', action);
            },
            liberaAvancarEtapa(val) {
                this.flAvancarEtapaTicket = val;
            },
            liberaUltimaEtapa(val) {
                if (!val) {
                    this.textAvancarEtapa = 'Avançar Para a Proxima Etapa';
                } else {
                    this.textAvancarEtapa = 'Finalizar Ticket';
                }
            },
            postAvancarEtapa() {
                this.$refs.modal_ticket.postAvancarEtapa();
                this.flAvancarEtapaTicket = false;
            },
            recarrega_dados() {

            },
            fechou_modal() {
                let $this = this;

                $this.showTicket = false;
                setTimeout(() => {
                    $this.showTicket = true;
                }, 300)
                $this.recarrega_dados();
                $this.$refs.ticket_historico.refreshModal();
                $this.isOpenModalTrocarSetor = false;
            },
            fechou_ticket() {
                let $this = this;

                $this.isOpenModalFinalizar = false;
                $this.exibir = false;
                $this.$emit("fecharModal", 'Ocorrencia');
            }
        },
        mounted() { },
        updated() { },
        watch: {
            p_exibir(n, o) {
                if (n) {
                    this.showModalTicket();
                }
            },
        },
    }

</script>

<style scoped lang="scss">
</style>